export default __webpack_public_path__ + "static/media/WNLProto1.176e4808.png";